import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
// import { AuthCredentials } from '../../core/auth/auth-credentials';
// import {
//     LoginAction,
//     LoginCompanyAction,
//     LoginKioskAction,
//     LoginRootAction,
//     LoginRootUserAction,
//     LoginSSOAction,
//     LoginUserAction,
//     LogoutAction,
//     SendPasswordForgetCodeAction,
//     SetAuthAction,
//     SetAuthRootAction,
// } from './login/login.actions';
// import { HttpClient } from '@angular/common/http';
// import { combineLatest, Observable, of } from 'rxjs';
// import { AuthPolicyService } from '../../core/auth/auth-policy.service';
// import { IObservableAction } from '@state/shared/actions/observable-action';
// import { AuthDataService } from '@api/auth-data.service';
// import {
//     FetchCompanyAction,
//     FetchUserAction,
//     SetCompanyAction,
//     SetUserAction,
// } from '../session/session.actions';
// import { LocalStorageService } from 'angular-2-local-storage';
// import { FeaturePolicyService } from '../../core/feature/feature-policy.service';
import { catchError, filter,map,switchMap, take, withLatestFrom } from 'rxjs/operators';
// import { ConnectionPermission } from '@models/connection/connection-permission';
import { environment } from '@environments/environment';
import { AuthSession } from '@core/models/auth/auth-session';
import { getUserAuthentication, getCompanyAuthentication, isAuthenticated, isUserAuthenticated } from './auth-selectors';
import { combineLatest, Observable, Observer, of } from 'rxjs';
import { $log } from '@core/utils/logger';
import { AuthDataService } from '@core/data/api/auth/auth-data.service';
import { LoginAction, LoginCompanyAction, LogoutAction, PostLogoutAction } from './login/login-actions';
import { AuthCredentials } from '@core/models/auth/auth-credentials';
import { InvalidateAccessTokenAction, InvalidateRefreshTokenAction, SetUserAuthAction, SetCompanyAuthAction, RequestVerificationCodeAction, SubmitVerificationCodeAction, ResetPasswordAction } from './auth-actions';
import { LocalStorageService } from '@core/local-storage/local-storage.service';
import { AccountType } from '@core/models/account/account-type';
import { ContinueAuthenticateDictionary } from '@core/models/auth/continue-authenticate-dictionary';
import { NoAction } from '../shared/actions/no-action';
import { IObservableAction } from '../shared/actions/observable-action';
import { RouteType } from '@core/router/route-type';
import { FEATURE_CERTIFICATE } from '@core/auth/feature-id';
import { SubscriptionTier } from '@core/models/billing/subscription-tier';
import { SessionService } from '../session/session.service';
import { ConnectionPermission } from '@core/models/connection/connection-permission';
import { AuthPolicyService } from '@core/auth/auth-policy.service';
import { getCompanyFeatures } from '../session/session-selectors';
import { FeaturePolicyService } from '@core/feature/feature-policy.service';
import { AccountRole } from '@core/models/account/account-role';
import { Company } from '@core/models/common/company';
import { AuthTokenType } from '@core/models/auth/auth-token-type';
// import { RouteType } from '../../core/router/route-type';
// import { STORE_USER_AUTH } from '../../core/data/localStorage/local-storage';
// import { isObject } from 'util';
// import { RouterGoAction } from '../router/router.actions';
// import { getFeatureFlags } from '../session/session.selectors';
// import { AccountTypes } from '@models/common/account-type';
// import { FetchSessionKioskAction } from '../session/kiosk/session-kiosk.actions';
// import { catchError } from 'rxjs/internal/operators';
// import { getSubscription } from '@state/app/billing.selectors';
// import {
//     FEATURE,
//     FEATURE_CERTIFICATE,
//     FEATURE_LOGBOOK,
//     FEATURE_ORDERS,
// } from '../../core/auth/feature-id';
// import { RestrictPremiumFeatureAction } from '../plan/plan.actions';
// import { PremiumFeatureTrigger } from '@models/upsell/premium-feature-trigger';
// import { BillingSubscription } from '@models/billing/billing-subscription';
// import { SubscriptionTier } from '@models/billing/subscription-tier';
// import { APP_LOGIN } from '@app/app.states';
// import { AppFlavour } from '@models/config/app-flavour';
// import { getWindow } from '../../vendor/window/window';

@Injectable({ providedIn: 'root' })
export class AuthService {
    constructor(
        private store$: Store<any>,
        private authPolicyService: AuthPolicyService,
        private featurePolicyService: FeaturePolicyService,
        private localStorageService: LocalStorageService,
        private authDataService: AuthDataService,
        private sessionService: SessionService
    ) {}

    /**
     * Defines HTTP headers for authorization of the current session.
     * @returns {{}}
     */
    getAuthorizationHeader(): string {
        let authHeader: string = '';
        let authSession: AuthSession;

        // Grab the root auth
        this.store$.select(getCompanyAuthentication)
            .pipe(take(1))
            .subscribe((session) => {
                authSession = session;
            });

        if (authSession && authSession.access_token) {
            authHeader = 'Bearer ' + authSession.access_token;

        } else {

            this.store$.select(getUserAuthentication)
                .pipe(take(1))
                .subscribe((session) => {
                    authSession = session;
                });

            if (authSession && authSession.access_token) {
                authHeader = 'Bearer ' + authSession.access_token;
            }
        }

        return authHeader;
    }

    getUserAuthentication(): Observable<AuthSession> {
        return this.store$.select(getUserAuthentication);
    }

    getCompanyAuthorization(): Observable<string> {
        return this.store$.select(getCompanyAuthentication)
            .pipe(map((authSession: AuthSession) => {
                return authSession?.access_token || null;
            }));
    }

    isDevSupport(): Observable<boolean> {
        return this.getUserAuthentication()
            .pipe(map((userAuth: AuthSession) => {
                return userAuth.role === AccountRole.SUPPORT;
            }));
    }

    /**
     * Defines HTTP headers for authorization of the root session.
     * @returns {{}}
     */
    getUserAuthorizationHeader(): string {
        let authHeader: string = '';
        let userAuthSession: AuthSession;

        // Grab the root auth
        this.store$.select(getUserAuthentication)
            .pipe(take(1))
            .subscribe((authSession) => {
                userAuthSession = authSession;
            });

        if (userAuthSession && userAuthSession.access_token) {
            authHeader = 'Bearer ' + userAuthSession.access_token;
        }

        return authHeader;
    }

    login(authCredentials: AuthCredentials): IObservableAction {
        const action: any = new LoginAction(authCredentials);
        this.store$.dispatch(action);
        return action;
    }

    loginCompany(companyId: string, isChangingCompanies: boolean = false, bypassRedirection: boolean = false): IObservableAction {
        const action: any = new LoginCompanyAction({ companyId, isChangingCompanies, bypassRedirection });
        this.store$.dispatch(action);
        return action;
    }

    logout() {
        this.store$.dispatch(new LogoutAction());
    }

    isAuthenticated() {
        return this.store$.select(isAuthenticated);
    }

    isUserAuthenticated() {
        return this.store$.select(isUserAuthenticated);
    }

    isValidRoute(path: string, routeType: RouteType): boolean {
        const matchSegments = path.split('/');
        const routes =
            environment.routes.hasOwnProperty(routeType) &&
            environment.routes[routeType];

        return !!routes.filter((route) => {
            let isValid = false;
            const matchRoute = route;
            if (route.charAt(0) === '/') {
                // Validate absolute matches
                if (route === '/') {
                    isValid = path === route;
                } else {
                    isValid = path.indexOf(matchRoute) === 0;
                }
            } else {
                // Validate relative matches
                isValid =
                    matchSegments && matchSegments.indexOf(matchRoute) >= 0;
            }

            return isValid;
        }).length;
    }

    isFeatureAvailable(featureId: string): Observable<boolean> {
        return this.store$.select(getCompanyFeatures)
                .pipe(map((features) =>
                    this.featurePolicyService.isFeatureAvailable(
                        features,
                        featureId
                    )
                ));
    }

    invalidateCompanyAccessToken() {
        this.store$.dispatch(new InvalidateAccessTokenAction());
    }

    invalidateCompanyRefreshToken() {
        this.store$.dispatch(new InvalidateRefreshTokenAction());
    }

    invalidateUserAccessToken() {
        this.store$.dispatch(new InvalidateAccessTokenAction({ isUser: true }));
    }

    invalidateUserRefreshToken() {
        this.store$.dispatch(new InvalidateRefreshTokenAction({ isUser: true }));
    }

    setAuth(authSession: AuthSession) {
        this.store$.dispatch(new SetUserAuthAction(authSession));
    }

    setRootAuth(authSession: AuthSession) {
        this.store$.dispatch(new SetCompanyAuthAction(authSession));
    }

    refreshToken2(isChangingCompanies?: boolean) {

        // observer: Observer<any>
        return new Observable((observer: Observer<any>) => {
            
            this.store$.select(getCompanyAuthentication)
                .pipe(
                    withLatestFrom(
                        this.store$.select(getUserAuthentication),
                    ),
                    take(1)
                ).subscribe(([auth, userAuth]: [AuthSession, AuthSession]) => {

                    // Attempt to refresh token as a company
                    this.authDataService.loginByRefreshToken( isChangingCompanies || !auth.refresh_token ?  userAuth.refresh_token : auth.refresh_token)
                        .pipe(
                            catchError((error) => {

                                if (isChangingCompanies || error?.status === 401) {
                                    observer.error(error);
    
                                    this.store$.dispatch(new PostLogoutAction());

                                    return of(error);
                                } else if (auth?.refresh_token) {
                                    const cad: ContinueAuthenticateDictionary = userAuth.cad;

                                    return this.authDataService.loginByAccessToken(cad.company_id, userAuth)
                                        .pipe(
                                            switchMap((companyLoginResponse) => {
                                                    this.store$.dispatch(new SetCompanyAuthAction(companyLoginResponse));
            
                                                    observer.next(null);
                                                    observer.complete();
    
                                                return []
            
                                            }),
                                            catchError((companyLoginError) => {
    
                                                return this.authDataService.loginByRefreshToken(userAuth.refresh_token)
                                                    .pipe(
    
                                                        switchMap(userRefreshTokenResponse => {
                                                            const userRefreshCad = userAuth.cad;
                                                            const newUserAuth: AuthSession = {
                                                                ...userAuth,
                                                                ...userRefreshTokenResponse
                                                            };
    
                                                            this.store$.dispatch(new SetUserAuthAction(newUserAuth));
    
                                                            return this.authDataService.loginByAccessToken(userRefreshCad.company_id, newUserAuth)
                                                                .pipe(
                                                                    switchMap((newCompanyLoginResponse) => {
    
                                                                        this.store$.dispatch(new SetCompanyAuthAction(newCompanyLoginResponse));
    
                                                                        observer.next(null);
                                                                        observer.complete();
    
                                                                        return [];
                                                                    }),
                                                                    catchError((newCompanyLoginError) => {
    
                                                                        alert('please log in again');
    
                                                                        observer.error(null);
    
                                                                        this.store$.dispatch(new PostLogoutAction());
    
                                                                        return of(newCompanyLoginError);
                                                                    })
                                                                );
                                                        }),
                                                        catchError((userRefreshTokenError) => {
    
                                                            observer.error(null);
    
                                                            // Note: This is the end of the line. company access, company refresh, user access & user refresh have failed
    
                                                            this.store$.dispatch(new PostLogoutAction());
    
                                                            return of(userRefreshTokenError);
                                                        })
                                                    );
    
    
                                                
                                            })
                                        );
                                }
                                
                            })
                        )
                        .subscribe((refreshTokenResponse) => {

                            if (isChangingCompanies) {

                                const userRefreshToken: AuthSession = {
                                    ...userAuth,
                                    access_token: refreshTokenResponse.access_token,
                                    refresh_token: refreshTokenResponse.refresh_token,
                                    expires_in: refreshTokenResponse.expires_in
                                }

                                this.store$.dispatch(new SetUserAuthAction(userRefreshToken));
                                this.store$.dispatch(new SetCompanyAuthAction({
                                    access_token: '',
                                    refresh_token: '',
                                    token_type: AuthTokenType.BEARER,
                                    expires_in: 0,
                                    _profile_type: AccountType.COMPANY,
                                    _profile_id: '',
                                }));

                            } else {
                                const rootAuthSession: AuthSession = {
                                    ...refreshTokenResponse,
                                    _profile_type: AccountType.COMPANY
                                };
    
                                this.store$.dispatch(new SetCompanyAuthAction(refreshTokenResponse));
                            }
                            

                            observer.next(null);
                            observer.complete();
                        }
                        // , (error) => {

                        //     console.log('user auth session => ', userAuth)
                        //     const cad: ContinueAuthenticateDictionary = userAuth.cad;

                        //     // this.authDataService.loginByAccessToken(cad.company_id, userAuth)
                        //     //     .subscribe(() => {

                        //     //     }, () => {

                        //     //     });


                        //     console.log('**** error => ', error);

                        // }
                        );

                });

        });
        
        

    }

    refreshToken(): Observable<any> {

        return of((observer: Observer<any>) => {
            const w: any = window;

            return this.store$.select(getUserAuthentication)
                    .pipe(
                        withLatestFrom(
                            this.store$.select(isAuthenticated),
                            this.store$.select(getCompanyAuthentication)
                        ),
                        switchMap(([authSession, isAuthenticated, rootAuthentication]: 
                            [AuthSession, boolean, AuthSession]) => {

                            return this.authDataService.loginByRefreshToken(authSession.refresh_token)
                                    .pipe(
                                        switchMap((refreshTokenResponse) => {

                                            observer.next(refreshTokenResponse);
                                            observer.complete();
                                            return [];
                                        }),
                                        catchError((error) => {
                                            observer.error('');
                                            return of(error);
                                        })
                                    );

                             

                        })
                    );
                    
                    });

            // return this.store$.select(getAuthentication)
            //         .pipe(
            //             withLatestFrom(
            //                 this.store$.select(isAuthenticated),
            //                 this.store$.select(isRootAuthentication),
            //                 this.store$.select(isCompanyLoggedIn),
            //                 this.store$.select(getRootAuthentication)
            //             ),

            //             take(1)
            //         )
            //         .subscribe(([authSession, isAuthenticated, isRootAuthentication, isCompanyLoggedIn, rootAuthentication]: 
            //             [AuthSession, boolean, boolean, boolean, AuthSession]) => {

            //                 console.log('@@@@@ 2');
                        
            //             // Validate is session was previously authenticated
            //             if (isAuthenticated) {


            //                 // Note: Solve pending requests at some point here

            //                 this.authDataService.loginByRefreshToken(authSession.refresh_token)
            //                     .subscribe((tokenResponse) => {

            //                         $log.log('this is the token response => token response');

            //                         if (isRootAuthentication) {
            //                             // Implement
            //                             // Note: Set new authentication object in local storage
            //                         }

            //                         let profileId: string = authSession._profile_id;
            //                         let isUserReloadRequired: boolean = false;

            //                         if (isCompanyLoggedIn) {

            //                             // Note: Implement
            //                             // Get company from session here

            //                         } else {

            //                             // Note: Implement
            //                             // Get user from session here
            //                         }

            //                         observer.next();
            //                         observer.complete();

            //                     });

            //             } else {
            //                 $log.error('Invalid tokens');
            //                 observer.error();
            //             }
            //         })



            // if (w.OSS && w.OSS.appV1 && w.OSS.appV1.refreshToken) {
            //     // Force token refresh via V1
            //     w.OSS.appV1.refreshToken().then((response) => {
            //         // Read auth session from V1
            //         const authorisationSet: any = this.localStorageService.get(
            //             STORE_USER_AUTH
            //         );

            //         let authState: any;

            //         authState = authorisationSet;

            //         const recentSession: any =
            //             authState.sessions[authState.sessions.length - 1];
            //         const rootSession: any = authState.root;

            //         // Force update of root tokens as required
            //         if (
            //             rootSession.access_token === recentSession.access_token
            //         ) {
            //             this.store$.dispatch(
            //                 new SetAuthRootAction(rootSession)
            //             );
            //         }

            //         // Update the authentication and user/company session
            //         this.store$.dispatch(new SetAuthAction(recentSession));
            //         this.store$.dispatch(new SetUserAction(response.user));
            //         this.store$.dispatch(
            //             new SetCompanyAction(response.company)
            //         );

            //         observer.next();
            //         observer.complete();
            //     });
            // } else {
            //     // Force token refresh (must have existing tokens)
            //     $log.info('Attempting to refresh token (v2)');
            //     this.sessionService
            //         .isAuthenticated()
            //         .pipe(take(1))
            //         .subscribe((isAuthenticated) => {
            //             if (isAuthenticated) {
            //                 combineLatest(
            //                     this.sessionService.getAuthentication(),
            //                     this.sessionService.getRootAuthentication(),
            //                     this.sessionService.isRootAuthentication()
            //                 )
            //                     .pipe(take(1))
            //                     .subscribe(
            //                         ([
            //                             authSession,
            //                             rootAuthSession,
            //                             isRootAuthentication,
            //                         ]: [AuthSession, AuthSession, boolean]) => {
            //                             this.loginViaRefreshToken(
            //                                 authSession.refresh_token
            //                             )
            //                                 .pipe(
            //                                     catchError((error) => {
            //                                         $log.error(
            //                                             'Refresh token failed.',
            //                                             error
            //                                         );
            //                                         observer.error(error);
            //                                         this.logout();

            //                                         return of(error);
            //                                     })
            //                                 )
            //                                 .subscribe((response) => {
            //                                     // Force update of root tokens as required
            //                                     if (isRootAuthentication) {
            //                                         const rootUpdate: AuthSession = {
            //                                             ...rootAuthSession,
            //                                             ...response,
            //                                         } as AuthSession;
            //                                         this.store$.dispatch(
            //                                             new SetAuthRootAction(
            //                                                 rootUpdate
            //                                             )
            //                                         );
            //                                     }

            //                                     // Update the authentication and user/company session
            //                                     this.store$.dispatch(
            //                                         new SetAuthAction(response)
            //                                     );
            //                                     switch (
            //                                         authSession._profile_type
            //                                     ) {
            //                                         case AccountTypes.KIOSK:
            //                                             this.store$.dispatch(
            //                                                 new FetchSessionKioskAction()
            //                                             );
            //                                             break;

            //                                         case AccountTypes.USER:
            //                                             this.store$.dispatch(
            //                                                 new FetchUserAction()
            //                                             );
            //                                             break;

            //                                         case AccountTypes.COMPANY:
            //                                             this.store$.dispatch(
            //                                                 new FetchUserAction()
            //                                             );
            //                                             this.store$.dispatch(
            //                                                 new FetchCompanyAction()
            //                                             );
            //                                             break;
            //                                     }

            //                                     observer.next();
            //                                     observer.complete();
            //                                 });
            //                         }
            //                     );
            //             } else {
            //                 // ERROR: API request requires session is authenticated
            //                 $log.error('Invalid tokens');
            //                 observer.error();
            //                 this.logout();
            //             }
            //         });
            // }
        // });
    }

    requestVerificationCode(request: { email?: string, phone?: string }): IObservableAction {
        const action: any = new RequestVerificationCodeAction(request);
        this.store$.dispatch(action);
        return action;
    }

    submitVerificationCode(code: string, id: string): IObservableAction {
        const action: any = new SubmitVerificationCodeAction({ code, id });
        this.store$.dispatch(action);
        return action;
    }

    resetPassword(password: string, id: string, code: string): IObservableAction {
        const action: any = new ResetPasswordAction({ code, id, password });
        this.store$.dispatch(action);
        return action;
    }

    isAuthorised(authId: string): Observable<boolean> {
        let isCompany: boolean = false;
        return combineLatest([
            this.sessionService.getCompany(),
            this.sessionService.getPermissions()
        ]).pipe(
            filter(([company, permissions]) => !!company && !!permissions),
            map(([company, permissions]: 
                [Company, ConnectionPermission[]]) => {
                return this.authPolicyService.isCompanyAuthenticated(
                    company,
                    permissions,
                    authId
                )
            })
        );
    }

    // /**
    //  * Logout current session.
    //  */
    // logout(): void {
    //     // TEST: force a logout state
    //     this.store$.dispatch(new LogoutAction());
    // }

    // /**
    //  * Login via email and password.
    //  */
    // login(credentials: AuthCredentials) {
    //     this.store$.dispatch(new LoginAction(credentials));
    // }

    // /**
    //  * Login company via access token.
    //  * @param companyId
    //  */
    // loginViaCompany(companyId: string): IObservableAction {
    //     const action$: any = new LoginCompanyAction(companyId);
    //     this.store$.dispatch(action$);

    //     return action$;
    // }

    // loginViaKiosk(pin: string): IObservableAction {
    //     const action$: any = new LoginKioskAction({ pin });
    //     this.store$.dispatch(action$);

    //     return action$;
    // }

    // loginViaRefreshToken(refreshToken: string): Observable<any> {
    //     return this.authDataService.loginByRefreshToken(refreshToken);
    // }

    // /**
    //  * Login the root worker account via access token.
    //  * @param userId
    //  * @returns {any}
    //  */
    // loginViaRootUser(userId: string): IObservableAction {
    //     const action$: any = new LoginRootUserAction(userId);
    //     this.store$.dispatch(action$);

    //     return action$;
    // }

    // loginViaWorker(userId: string) {
    //     this.store$.dispatch(new LoginUserAction(userId));
    // }

    // loginViaRoot() {
    //     this.store$.dispatch(new LoginRootAction());
    // }

    // /**
    //  * Login via single sign-on.
    //  * @param ssoId
    //  * @param ssoProvider
    //  */
    // loginViaSSO(ssoId: string, ssoProvider: string): IObservableAction {
    //     const action$: any = new LoginSSOAction({ ssoId, ssoProvider });
    //     this.store$.dispatch(action$);

    //     return action$;
    // }

    // sendForgetPasswordCode(email?: string, phone?: string): IObservableAction {
    //     const action$: any = new SendPasswordForgetCodeAction({
    //         phone,
    //         email,
    //     });
    //     this.store$.dispatch(action$);
    //     return action$;
    // }

    // /**
    //  * Navigates to login.
    //  */
    // redirectToLogin() {
    //     this.store$.dispatch(new RouterGoAction({ name: APP_LOGIN }));
    // }

    // /**
    //  * Navigates to restricted.
    //  */
    // redirectToRestricted() {
    //     this.store$.dispatch(
    //         new RouterGoAction({ name: environment.paths.restricted.url })
    //     );
    // }

    // refreshToken(): Observable<any> {
    //     return Observable.create((observer) => {
    //         const w: any = window;
    //         if (w.OSS && w.OSS.appV1 && w.OSS.appV1.refreshToken) {
    //             // Force token refresh via V1
    //             w.OSS.appV1.refreshToken().then((response) => {
    //                 // Read auth session from V1
    //                 const authorisationSet: any = this.localStorageService.get(
    //                     STORE_USER_AUTH
    //                 );

    //                 let authState: any;

    //                 if (environment.flavour === AppFlavour.DEFAULT) {
    //                     authState = authorisationSet;
    //                 } else {
    //                     // use multi-session approach
    //                     const tabId: number = getWindow().tabId;
    //                     authState = authorisationSet[tabId];
    //                 }

    //                 const recentSession: any =
    //                     authState.sessions[authState.sessions.length - 1];
    //                 const rootSession: any = authState.root;

    //                 // Force update of root tokens as required
    //                 if (
    //                     rootSession.access_token === recentSession.access_token
    //                 ) {
    //                     this.store$.dispatch(
    //                         new SetAuthRootAction(rootSession)
    //                     );
    //                 }

    //                 // Update the authentication and user/company session
    //                 this.store$.dispatch(new SetAuthAction(recentSession));
    //                 this.store$.dispatch(new SetUserAction(response.user));
    //                 this.store$.dispatch(
    //                     new SetCompanyAction(response.company)
    //                 );

    //                 observer.next();
    //                 observer.complete();
    //             });
    //         } else {
    //             // Force token refresh (must have existing tokens)
    //             $log.info('Attempting to refresh token (v2)');
    //             this.sessionService
    //                 .isAuthenticated()
    //                 .pipe(take(1))
    //                 .subscribe((isAuthenticated) => {
    //                     if (isAuthenticated) {
    //                         combineLatest(
    //                             this.sessionService.getAuthentication(),
    //                             this.sessionService.getRootAuthentication(),
    //                             this.sessionService.isRootAuthentication()
    //                         )
    //                             .pipe(take(1))
    //                             .subscribe(
    //                                 ([
    //                                     authSession,
    //                                     rootAuthSession,
    //                                     isRootAuthentication,
    //                                 ]: [AuthSession, AuthSession, boolean]) => {
    //                                     this.loginViaRefreshToken(
    //                                         authSession.refresh_token
    //                                     )
    //                                         .pipe(
    //                                             catchError((error) => {
    //                                                 $log.error(
    //                                                     'Refresh token failed.',
    //                                                     error
    //                                                 );
    //                                                 observer.error(error);
    //                                                 this.logout();

    //                                                 return of(error);
    //                                             })
    //                                         )
    //                                         .subscribe((response) => {
    //                                             // Force update of root tokens as required
    //                                             if (isRootAuthentication) {
    //                                                 const rootUpdate: AuthSession = {
    //                                                     ...rootAuthSession,
    //                                                     ...response,
    //                                                 } as AuthSession;
    //                                                 this.store$.dispatch(
    //                                                     new SetAuthRootAction(
    //                                                         rootUpdate
    //                                                     )
    //                                                 );
    //                                             }

    //                                             // Update the authentication and user/company session
    //                                             this.store$.dispatch(
    //                                                 new SetAuthAction(response)
    //                                             );
    //                                             switch (
    //                                                 authSession._profile_type
    //                                             ) {
    //                                                 case AccountTypes.KIOSK:
    //                                                     this.store$.dispatch(
    //                                                         new FetchSessionKioskAction()
    //                                                     );
    //                                                     break;

    //                                                 case AccountTypes.USER:
    //                                                     this.store$.dispatch(
    //                                                         new FetchUserAction()
    //                                                     );
    //                                                     break;

    //                                                 case AccountTypes.COMPANY:
    //                                                     this.store$.dispatch(
    //                                                         new FetchUserAction()
    //                                                     );
    //                                                     this.store$.dispatch(
    //                                                         new FetchCompanyAction()
    //                                                     );
    //                                                     break;
    //                                             }

    //                                             observer.next();
    //                                             observer.complete();
    //                                         });
    //                                 }
    //                             );
    //                     } else {
    //                         // ERROR: API request requires session is authenticated
    //                         $log.error('Invalid tokens');
    //                         observer.error();
    //                         this.logout();
    //                     }
    //                 });
    //         }
    //     });
    // }

    // /**
    //  * Navigates to default home.
    //  */
    // redirectToHome() {
    //     // TODO: Refactor out session service and use session selectors!
    //     this.sessionService
    //         .isCompanyLoggedIn()
    //         .pipe(first(), withLatestFrom(this.sessionService.isIHDAvailable()))
    //         .subscribe(([isCompany, isIHDAvailable]) => {
    //             let homePath;
    //             if (isCompany) {
    //                 homePath = isIHDAvailable
    //                     ? environment.paths.home.employerIHD.url
    //                     : environment.paths.home.employer.url;
    //             } else {
    //                 homePath = environment.paths.home.worker.url;
    //             }
    //             this.store$.dispatch(new RouterGoAction({ name: homePath }));
    //         });
    // }

    // getRedirectToHomeState(): Observable<any> {
    //     return this.sessionService.isCompanyLoggedIn().pipe(
    //         first(),
    //         withLatestFrom(this.sessionService.isIHDAvailable()),
    //         map(([isCompany, isIHDAvailable]) => {
    //             let homeState;
    //             if (isCompany) {
    //                 homeState = isIHDAvailable
    //                     ? environment.paths.home.employerIHD.state
    //                     : environment.paths.home.employer.state;
    //             } else {
    //                 homeState = environment.paths.home.worker.state;
    //             }
    //             return homeState;
    //         })
    //     );
    // }

    // /**
    //  * Defines HTTP headers for authorization of the current session.
    //  * @returns {{}}
    //  */
    // getAuthorizationHeader(): string {
    //     let authHeader: string = '';
    //     let authSession: AuthSession;

    //     // Grab the root auth
    //     this.sessionService
    //         .getAuthentication()
    //         .pipe(take(1))
    //         .subscribe((session) => {
    //             authSession = session;
    //         });

    //     if (authSession && authSession.access_token) {
    //         authHeader = 'Bearer ' + authSession.access_token;
    //     }

    //     return authHeader;
    // }

    

    

    // isFeatureAvailable(featureId: string): Observable<boolean> {
    //     let isCompany: boolean = false;

    //     return this.sessionService.isCompanyLoggedIn().pipe(
    //         mergeMap((isCompanyLoggedIn): any => {
    //             isCompany = isCompanyLoggedIn;
    //             return isCompanyLoggedIn
    //                 ? this.sessionService.getCompanyFeatures()
    //                 : this.sessionService.getUserFeatures();
    //         }),
    //         map((features) =>
    //             this.featurePolicyService.isFeatureAvailable(
    //                 features,
    //                 featureId
    //             )
    //         )
    //     );
    // }

    // /**
    //  * Tests the feature id with the AuthPolicy
    //  * @param featureId
    //  */
    // can(featureId: string): Observable<boolean> {
    //     return combineLatest([
    //         this.sessionService.isCompanyLoggedIn(),
    //         this.store$.select(getSubscription),
    //     ]).pipe(
    //         map(
    //             ([isCompanyLoggedIn, subscription]: [
    //                 boolean,
    //                 BillingSubscription
    //             ]) => {
    //                 return this.authPolicyService.can(featureId);
    //             }
    //         )
    //     );
    // }

    // canFeatureFlag(flag: string): Observable<boolean> {
    //     return combineLatest([
    //         this.getFeatureFlags(),
    //         this.store$.select(getSubscription),
    //     ]).pipe(
    //         map((flags) => {
    //             return this.featurePolicyService.can(flag);
    //         })
    //     );
    // }

    // canAccessFeature(featureId: string): Observable<boolean> {
    //     return combineLatest([
    //         this.sessionService.isCompanyLoggedIn(),
    //         this.store$.select(getSubscription),
    //     ]).pipe(
    //         map(
    //             ([isCompanyLoggedIn, subscription]: [
    //                 boolean,
    //                 BillingSubscription
    //             ]) => {
    //                 return this.featurePolicyService.can(featureId);
    //             }
    //         )
    //     );
    // }

    // canAccessFlavour(flavour: AppFlavour): Observable<boolean> {
    //     return of(flavour === environment.flavour);
    // }

    // /**
    //  * Returns a specific feature flag
    //  * @param {string} featureId
    //  * @returns {Observable<boolean>}
    //  */
    // getFeatureFlag(featureId: string): Observable<boolean> {
    //     return this.store$.pipe(
    //         select(getFeatureFlags),
    //         map((featureFlags) => {
    //             if (featureFlags && featureFlags.hasOwnProperty(featureId)) {
    //                 if (
    //                     isObject(featureFlags[featureId]) &&
    //                     featureFlags[featureId].hasOwnProperty('current')
    //                 ) {
    //                     return featureFlags[featureId].current;
    //                 } else {
    //                     return featureFlags[featureId];
    //                 }
    //             } else {
    //                 return false;
    //             }
    //         })
    //     );
    // }

    // isDemo(): boolean {
    //     return environment.launchDarkly.defaults['demo-mode'];
    // }

    // /**
    //  * Returns all feature flags.
    //  * @returns {Observable<boolean>}
    //  */
    // getFeatureFlags(): Observable<boolean> {
    //     return this.store$.pipe(select(getFeatureFlags));
    // }

    /**
     * Resolves an auth block and guards into a boolean.
     * @param data
     * @returns {Promise<boolean>}
     */
    resolveGuards(
        data: any
    ): Promise<{ isEnabled: boolean; upsell: boolean; process?: any }> {
        let isValid: boolean = false;

        return new Promise<{
            isEnabled: boolean;
            upsell: boolean;
            process?: any;
        }>((resolve, reject) => {
            if (data && data.guards) {
                const featureId: string = data.featureId;
                const featureTier: SubscriptionTier = data.tier;
                const guards: any = data.guards;
                const guardRequests: any[] = [];
                const guardMap: any = {};

                /**
                 * For all the guards build a request map lookup, so the results can be pulled using the last parameter
                 * in the combineLatest operator.
                 */
                // NOTE: Temporary disabled below
                // if (guards.auth) {
                //     guardRequests.push(this.isAuthorised(featureId));
                //     guardMap.auth = guardRequests.length - 1;
                // }

                // if (guards.feature || guards.upsell) {
                //     guardRequests.push(this.isFeatureAvailable(featureId));
                //     guardMap.feature = guardRequests.length - 1;
                // }

                // if (guards.flag) {
                //     guardRequests.push(this.getFeatureFlag(featureId));
                //     guardMap.flag = guardRequests.length - 1;
                // }

                // if (guards.upsell) {
                //     guardRequests.push(this.canAccessFeature(featureId));
                //     guardMap.hasUpsellAccess = guardRequests.length - 1;
                // }

                // if (guards.flavour) {
                //     guardRequests.push(this.canAccessFlavour(guards.flavour));
                //     guardMap.hasAccessToFlavour = guardRequests.length - 1;
                // }

                // This is the latest combineLatest param that will use the request map to convert the array of responses back into an object.
                guardRequests.push((...res) => {
                    let resObj = {};
                    Object.keys(guardMap).forEach((key) => {
                        resObj[key] = res[guardMap[key]];
                    });
                    return [resObj];
                });

                combineLatest(...guardRequests)
                    .pipe(take(1))
                    .subscribe(
                        ([res]: [any]) => {
                            let isAuthorised: boolean;
                            let isFeatureAvailable: boolean;
                            let upsell: boolean = false;
                            let process: any = null;
                            let hasUpsellAccess: boolean = res.hasUpsellAccess;

                            // Validate feature flag first if present
                            if (guards.flag) {
                                isValid = res.flag;
                            }

                            // Validate item can be shown to app flavour
                            if (
                                guards.flavour &&
                                (!guards.flag || (guards.flag && isValid))
                            ) {
                                isValid = res.hasAccessToFlavour;
                            }

                            if (
                                (!guards.flavour ||
                                    (guards.flavour && isValid)) &&
                                (!guards.flag || (guards.flag && isValid))
                            ) {
                                if (guards.upsell && !hasUpsellAccess) {
                                    isFeatureAvailable = res.feature;
                                    upsell = guards.upsell;

                                    // switch (featureId) {
                                    //     case FEATURE_CERTIFICATE:
                                    //         process = this
                                    //             .processCertificatesRestriction;
                                    //         break;

                                    //     case FEATURE_LOGBOOK:
                                    //         process = this
                                    //             .processLogbookRestriction;
                                    //         break;
                                    // }

                                    isValid = guards.auth
                                        ? isFeatureAvailable && res.auth
                                        : isFeatureAvailable;
                                } else if (guards.auth && guards.feature) {
                                    isAuthorised = res.auth;
                                    isFeatureAvailable = res.feature;
                                    isValid =
                                        isFeatureAvailable && isAuthorised;
                                } else if (guards.auth && !guards.feature) {
                                    isAuthorised = res.auth;
                                    isValid = isAuthorised;
                                } else if (!guards.auth && guards.feature) {
                                    isFeatureAvailable = res.feature;
                                    isValid = isFeatureAvailable;
                                } else if (!guards.auth && !guards.feature) {
                                    isValid = true;
                                }
                            }

                            resolve({ isEnabled: isValid, upsell, process });
                        },
                        (error) => {
                            // ERROR: Resolve failed
                            $log.error('Failed to resolve guards', error);
                            reject(false);
                        }
                    );
            }
        });
    }

    // /**
    //  * Validates the route is defined as PUBLIC or PRIVATE.
    //  * @param {string} path
    //  * @param {string} routeType
    //  * @returns {boolean}
    //  */
    // public isValidRoute(path: string, routeType: RouteType): boolean {
    //     const matchSegments = path.split('/');
    //     const routes =
    //         environment.routes.hasOwnProperty(routeType) &&
    //         environment.routes[routeType];

    //     return !!routes.filter((route) => {
    //         let isValid = false;
    //         const matchRoute = route;
    //         if (route.charAt(0) === '/') {
    //             // Validate absolute matches
    //             if (route === '/') {
    //                 isValid = path === route;
    //             } else {
    //                 isValid = path.indexOf(matchRoute) === 0;
    //             }
    //         } else {
    //             // Validate relative matches
    //             isValid =
    //                 matchSegments && matchSegments.indexOf(matchRoute) >= 0;
    //         }
    //         return isValid;
    //     }).length;
    // }

    // private processCertificatesRestriction = () => {
    //     this.store$.dispatch(
    //         new RestrictPremiumFeatureAction({
    //             feature: PremiumFeatureTrigger.CERTIFICATIONS,
    //         })
    //     );
    //     this.sessionService.closeMenu();
    // };

    // private processLogbookRestriction = () => {
    //     this.store$.dispatch(
    //         new RestrictPremiumFeatureAction({
    //             feature: PremiumFeatureTrigger.LOGBOOK,
    //         })
    //     );
    //     this.sessionService.closeMenu();
    // };
}
